var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPinCircleOutsideLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41 17C54.2548 17 65 27.7452 65 41H17C17 27.7452 27.7452 17 41 17Z",
    fill: "url(#paint0_linear_2454_5943)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 17C54.2548 17 65 27.7452 65 41C65 54.2548 54.2548 65 41 65C27.7452 65 17 54.2548 17 41C17 27.7452 27.7452 17 41 17ZM41 20C29.402 20 20 29.402 20 41C20 52.598 29.402 62 41 62C52.598 62 62 52.598 62 41C62 29.402 52.598 20 41 20Z",
    fill: "url(#paint1_linear_2454_5943)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2454_5943",
    x1: 41,
    y1: 17,
    x2: 41,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2454_5943",
    x1: 41,
    y1: 17,
    x2: 41,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPinCircleOutsideLight);
export default __webpack_public_path__ + "static/media/ic_pin_circle_outside_light.3fe84b5254aa118f83a340e2bd932717.svg";
export { ForwardRef as ReactComponent };